import { read } from 'fs';
import React, { useEffect, useRef, useState } from 'react';
import AutosizeInput from 'react-input-autosize';
import onClickOutside from 'react-onclickoutside';

const PageNumberControl = ({
  currentPageNumber,
  setPageNumber,
  pageCount,
  readOnly,
}: {
  currentPageNumber: number;
  setPageNumber: (val: any) => void;
  pageCount: number;
  readOnly?: boolean;
}) => {
  const [pageNumberValue, setpageNumberValue] = useState(currentPageNumber);
  const pageNumberElement = useRef<any>(null);

  //@ts-expect-error because of the way react-onclickoutside is written, it doesn't recognize the type of the function
  PageNumberControl.handleClickOutside = () =>
    pageNumberElement.current && pageNumberElement.current.blur();

  const changePageNumber = () => {
    const newNum = Math.min(Math.max(pageNumberValue, 1), pageCount);
    setPageNumber(newNum);
    setpageNumberValue(newNum);
  };

  useEffect(() => {
    if (!pageNumberElement.current) return;

    pageNumberElement.current.input.readOnly = !!readOnly;
  }, [readOnly]);

  return (
    <div
      className="pageNumber"
      onClick={() => pageNumberElement.current && pageNumberElement.current.focus()}
    >
      <AutosizeInput
        ref={(el: any) => {
          pageNumberElement.current = el;
          if (!el) return;

          el.input.readOnly = !!readOnly;
        }}
        value={pageNumberValue || ''}
        onChange={(event: any) => {
          const re = /^[0-9\b]+$/;
          if (event.target.value === '' || re.test(event.target.value))
            setpageNumberValue(event.target.value);
        }}
        onBlur={changePageNumber}
        onKeyDown={(e: any) => {
          e.stopPropagation();
          if (e.key === 'Enter') pageNumberElement.current.blur();
        }}
      />
      <span>{' / ' + pageCount}</span>
    </div>
  );
};

export default onClickOutside(PageNumberControl, {
  //@ts-expect-error because of the way react-onclickoutside is written, it doesn't recognize the type of the function
  handleClickOutside: () => PageNumberControl.handleClickOutside,
});
